<template>
  <c-modal-form
    :id="$getConst('FORM_SOS_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    :error="error"
    fields-required
    title="Нужна срочная помощь!"
    @submit="submit()"
  >
    <c-alert
      v-if="!sosAvailable"
      type="warning"
    >
      Извините, но недавно вы уже отправляли заявку. Вы сможете отправить новую заявку через <span class="text-bold">{{ [sosAvailableTime, 'seconds'] | duration('humanize') }}</span>.
    </c-alert>
    <form>
      <c-select
        v-model="domain"
        :options="domainOptions"
        form-group
        first-option-disabled
      />
      <c-select
        v-model="reason"
        :options="reasonOptions"
        form-group
        first-option-disabled
      />
      <c-textarea
        v-model="comment"
        :form-group="true"
        :row-count="4"
        :placeholder="commentPlaceholderText"
      />
      <modal-files-upload
        id="sos"
        v-model="files"
        :max-files-size="$getConst('UPLOAD_MAX_FILES_SIZE')"
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CSelect from '../../../../../../../resources/js/components/ui/CSelect'
import CTextarea from '../../../../../../../resources/js/components/ui/CTextarea'
import CAlert from '../../../../../../../resources/js/components/ui/CAlert'
import ModalFilesUpload from '../../../../../../../resources/js/components/ModalFilesUpload'
import { mapActions, mapGetters, mapState } from 'vuex'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import files from '../../../../../../../resources/js/mixins/files'
import apiService from '../../apiService'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно SOS.
 */
export default {
  name: 'Sos',
  components: {
    CModalForm,
    CSelect,
    CTextarea,
    CAlert,
    ModalFilesUpload,
    DemoDenied
  },
  mixins: [form, modal, files],
  data () {
    return {
      domain: '',
      reason: '',
      comment: '',
      sosAvailableTime: 0,
      sosAvailableFetching: false,
      files: []
    }
  },
  computed: {
    /**
     * Элементы для выпадающего списка доменов.
     *
     * @returns {*[]}
     */
    domainOptions () {
      return ['*Выберите сайт, где обнаружена проблема', ...this.clientDomains]
    },
    /**
     * Элементы для выпадающего списка с причинами обращения.
     *
     * @returns {(string|*)[]}
     */
    reasonOptions () {
      return ['*Укажите причину обращения', ...this.reasonsTitles]
    },
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.sending || this.clientDomainsFetching || this.formsSosListReasonsFetching || this.sosAvailableFetching)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domain && this.reason && (this.comment || (!this.isReasonCommentRequired(this.reason) && !this.comment)) && this.sosAvailable && this.isFilesSizeCorrect(this.files, this.$getConst('UPLOAD_MAX_FILES_SIZE')) && !this.isDemo)
    },
    /**
     * Можно ли отправить новую заявку.
     *
     * @returns {boolean}
     */
    sosAvailable () {
      return this.sosAvailableTime === 0
    },
    /**
     * Текст для плейсхолдера комментария.
     *
     * @returns {string}
     */
    commentPlaceholderText () {
      return (this.isReasonCommentRequired(this.reason) ? '*' : '') + 'Дополнительные комментарии'
    },
    ...mapGetters({
      reasonsTitles: 'seo/forms/sosListReasons/titles',
      isReasonCommentRequired: 'seo/forms/sosListReasons/isReasonCommentRequired',
      isDemo: 'seo/client/info/isDemo'
    }),
    ...mapState({
      clientDomains: state => state.seo.client.domains.domains,
      clientDomainsFetching: state => state.seo.client.domains.fetching,
      formsSosListReasonsFetching: state => state.seo.forms.sosListReasons.fetching
    })
  },
  watch: {
    domain (domain) {
      if (domain) {
        this.fetchFormsSosAvailability()
      }
    }
  },
  mounted () {
    this.fetchReasons()

    $(`#${this.$getConst('FORM_SOS_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })

    setInterval(() => {
      if (this.sosAvailableTime > 0) {
        this.sosAvailableTime = this.sosAvailableTime - 1
      }
    }, 1000)
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.domain = ''
      this.reason = ''
      this.comment = ''
      this.sosAvailableTime = 0
      this.files = []
      this.error = false
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postFormsSosAppeal(this.domain, this.reason, this.comment, this.files)
        .then(() => {
          this.hideModal(this.$getConst('FORM_SOS_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    },
    /**
     * Загружает информацию через какое время (секунды) будет доступна повторная отправка формы.
     */
    fetchFormsSosAvailability () {
      this.sosAvailableFetching = true

      apiService.getFormsSosAvailability(this.domain)
        .then(response => {
          this.sosAvailableTime = response.data.time

          this.sosAvailableFetching = false
        })
        .catch(() => {
          this.sosAvailableFetching = false
        })
    },
    ...mapActions({
      fetchReasons: 'seo/forms/sosListReasons/fetch'
    })
  }
}
</script>
